// ETL ワークフロー画面の共通ヘルパー・定数。
// ETLWorkflowPage / CreateWorkflowModal / WorkflowEditModal で共有して利用する。
// 通知のターゲット/テンプレート設定は、通知フローの設計が固まるまで一時的に非表示にする。
export const HIDE_NOTIFICATION_PLANNING_SETTINGS = true;
// 指定ステップがエージェント変換ステップかどうかを判定する。
export const isAgentTransformStep = (step) => step.step_kind === 'agent_transform' ||
    step.step_kind === 'agent_map_transform' ||
    (step.step_type === 'transform' && step.config?.agent_id);
// ワークフローのステップ構成が V2 ウィザードで編集可能かどうかを判定する。
export const isWorkflowEditableByV2Steps = (steps = []) => {
    const supportedAgentSteps = steps.filter(isAgentTransformStep);
    const extractStep = steps.find((step) => step.step_kind === 'upload_file_extract' || step.step_kind === 'kujyu_reports_extract');
    if (steps.length === 1) {
        return supportedAgentSteps.length === 1;
    }
    if (steps.length === 2 && supportedAgentSteps.length === 1) {
        const agentStep = supportedAgentSteps[0];
        const loadStep = steps.find((step) => step.step_kind === 'database_fallback_load');
        if (!loadStep || !Array.isArray(loadStep.depends_on)) {
            return false;
        }
        return loadStep.depends_on.length === 1 && loadStep.depends_on[0] === agentStep.step_id;
    }
    if (steps.length === 3 && supportedAgentSteps.length === 1 && extractStep) {
        const agentStep = supportedAgentSteps[0];
        const loadStep = steps.find((step) => step.step_kind === 'database_fallback_load');
        if (!Array.isArray(agentStep.depends_on) || !loadStep || !Array.isArray(loadStep.depends_on)) {
            return false;
        }
        return (agentStep.depends_on.length === 1 &&
            agentStep.depends_on[0] === extractStep.step_id &&
            loadStep.depends_on.length === 1 &&
            loadStep.depends_on[0] === agentStep.step_id);
    }
    return false;
};
